var map = {
	"./piece1.png": 3062,
	"./piece2.png": 1798,
	"./piece3.png": 1065,
	"./piece4.png": 2396,
	"./piece5.png": 319,
	"./piece6.png": 2416,
	"./piece7.png": 126,
	"./piece8.png": 2846,
	"./piece9.png": 2478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7749;